import { TARGET_ORIGIN } from '@constants/config';

interface ISendPostMessage {
  type: string;
  data?: unknown;
  keyName?: string;
}

export const sendPostMessage = ({ type, data, keyName }: ISendPostMessage) => {
  window.parent.postMessage({ type, [keyName ?? 'data']: data }, TARGET_ORIGIN);
};
